export class PassSectionFieldAliases {
  static PASS_KIND = 'pass_kind'
  static CONTRACT_NUMBER = 'contract_number'
  static CONTRACT_DATE_OF = 'contract_date_of'
  static CONTRACT_DATE_TO = 'contract_date_to'
  static ADDITIONAL_PURPOSE = 'additional_purpose'
  static TIME_TO = 'time_to'
  static TIME_OF = 'time_of'
  static TIME_INTERVAL = 'time_interval'
  static PERIOD_TO = 'period_to'
  static PERIOD_OF = 'period_of'
  static TIME_TYPE = 'time_type'
  static TERMINAL_SUBDIVISION = 'terminal_subdivision'
  static AGENT_ORGANIZATION = 'agent_organization'
  static TERMINAL_REGION = 'terminal_region'
  static APPLICATION_PURPOSE = 'application_purpose'
  static VISITORS_CATEGORY = 'visitors_category'
  static PAYMENT_TYPE = 'payment_type'
}
